import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TQuerystringParams } from "../../utils/miscellaneous";

const initialState: TQuerystringParams = {
  organization_id: "",
  account_id: "",
  period: undefined,
  start_date: undefined,
  end_date: undefined,
  page: 1,
  items_per_page: 10,
  has_payable_accounts: undefined,
  has_goods_receipt: undefined,
  search: undefined,
  launch_status: undefined,
  manifestation_status: undefined,
  role: undefined,
  status: undefined,
};

const querystringSlice = createSlice({
  name: "querystring",
  initialState,
  reducers: {
    SET_QUERYSTRING: (state, action: PayloadAction<TQuerystringParams>) => {
      state = action.payload;

      return state;
    },
  },
});

export const { SET_QUERYSTRING } = querystringSlice.actions;
export default querystringSlice.reducer;
